import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

var customActions = { }

export const SelfAssessmentResource = () => {
  return Vue.resource('selfassessment{/id}', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/selfassessment.js